import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import Dropdown from "components/Dropdown";
import TitledContainer, { StaticText } from "components/TitledContainer";

import styles from "./TitledInputDropdown.css";

const TitledInputDropdown = (props) => {
  const {
    dropdownValue,
    dropdownValues,
    isEdit,
    isRequired,
    onEdit,
    onSelect,
    title,
    value,
    valueExtractor,
  } = props;

  return (
    <TitledContainer
      isEdit={isEdit}
      isEmpty={!dropdownValue || !value}
      onEdit={onEdit}
      title={title}
      isEditable
    >
      <div className={cx(styles.root, { [styles.edit]: isEdit })}>
        <div className={styles.input}>
          {isEdit ? (
            <input
              className={cx({ [styles.required]: isRequired && !value })}
              onChange={({ target }) =>
                target.value.match(/^$|[0-9.,]+$/) ? props.onInput(target.value) : null
              }
              type="text"
              value={value || ""}
            />
          ) : (
            <StaticText text={value} />
          )}
        </div>
        <div className={styles.dropdown}>
          {isEdit ? (
            <Dropdown
              inputValueExtractor={valueExtractor}
              onChange={onSelect}
              selectedValues={dropdownValue ? [dropdownValue] : []}
              valueExtractor={(v) => ({ label: valueExtractor(v) })}
              values={dropdownValues}
            />
          ) : (
            <span>{dropdownValue && valueExtractor(dropdownValue)}</span>
          )}
        </div>
      </div>
    </TitledContainer>
  );
};

TitledInputDropdown.propTypes = {
  dropdownValue: PropTypes.string,
  dropdownValues: PropTypes.arrayOf(PropTypes.string),
  isEdit: PropTypes.bool,
  isRequired: PropTypes.bool,
  onEdit: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueExtractor: PropTypes.func,
};

TitledInputDropdown.defaultProps = {
  isRequired: false,
  value: "",
  dropdownValue: "",
  valueExtractor: (v) => v,
};

export default TitledInputDropdown;
